export default function DeliveryTracker({ chain = [] }) {
  if (!chain.length) return null;

  return (
    <div className="delivery-simple">
      {chain.map((step, index) => (
        <span key={index} className="delivery-step">
          <span className="delivery-dot" />

          {step.name || step.userName || "-"} ({step.role})

          {index !== chain.length - 1 && (
            <span className="delivery-arrow"> → </span>
          )}
        </span>
      ))}
    </div>
  );
}